






















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
class TeamDetail extends Vue {
    @Prop({type: String})
    public imageLink!: string;

    @Prop({type: String})
    public text!: string;

    @Prop({type: String})
    public mail!: string;

    @Prop({type: String})
    public phone!: string;

    @Prop({type: String})
    public facebookLink!: string;

    @Prop({type: String})
    public instagramLink!: string;

    @Prop({type: String})
    public linkedInLink!: string;

    @Prop({type: String})
    public contactTitle!: string;
}

export default TeamDetail;



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/teamDetail.vue